// Cart Drawer functionality
window.cartDrawer = {
  isOpen: false,
  
  init() {
    const backdrop = document.getElementById('cart-drawer-backdrop');
    const closeBtn = document.getElementById('cart-drawer-close');
    const drawer = document.getElementById('cart-drawer');
    
    if (backdrop) {
      backdrop.addEventListener('click', () => this.close());
    }
    
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }
    
    // Load cart on init
    this.loadCart();
    
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.loadCart();
      this.updateCartCount();
    });
  },
  
  open() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.classList.add('open');
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
      this.loadCart();
    }
  },
  
  close() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.classList.remove('open');
      this.isOpen = false;
      document.body.style.overflow = '';
    }
  },
  
  async loadCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      this.renderCart(cart);
      this.updateCartCount();
    } catch (error) {
      console.error('Error loading cart:', error);
    }
  },
  
  renderCart(cart) {
    const itemsContainer = document.getElementById('cart-drawer-items');
    const totalEl = document.getElementById('cart-drawer-total');
    const countEl = document.getElementById('cart-drawer-count');
    
    if (!itemsContainer) return;
    
    if (cart.items.length === 0) {
      itemsContainer.innerHTML = `
        <div class="cart-drawer-empty">
          <div class="cart-drawer-empty-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
          </div>
          <p class="cart-drawer-empty-text">Tu carrito está vacío.</p>
          <button class="cart-drawer-empty-button" onclick="window.cartDrawer.close()">
            Descubrir Colección
          </button>
        </div>
      `;
      // Si el carrito está vacío, limpiamos también el total
      if (totalEl) totalEl.textContent = '0,00€';
      return;
    }
    
    itemsContainer.innerHTML = cart.items.map((item, index) => `
      <div class="cart-drawer-item">
        <div class="cart-drawer-item-image">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="cart-drawer-item-content">
          <div class="cart-drawer-item-header">
            <h3 class="cart-drawer-item-name">${item.product_title}</h3>
            <button class="cart-drawer-item-remove" onclick="window.cartDrawer.removeItem(${index})">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `
            <p class="cart-drawer-item-variant">${item.variant_title}</p>
          ` : ''}
          <div class="cart-drawer-item-footer">
            <p class="cart-drawer-item-quantity">Cant: ${item.quantity}</p>
            <p class="cart-drawer-item-price">${(item.final_line_price / 100).toFixed(2).replace('.', ',')}€</p>
          </div>
        </div>
      </div>
    `).join('');
    
    if (totalEl) {
      // CAMBIO AQUÍ: Total en Euros, con coma y texto de IVA
      const totalPrice = (cart.total_price / 100).toFixed(2).replace('.', ',');
      totalEl.innerHTML = `${totalPrice}€ <span style="font-size: 0.8em; font-weight: normal; color: #666;">(IVA incluido)</span>`;
    }
    
    if (countEl) {
      countEl.textContent = `(${cart.item_count})`;
    }
  },
  
  async removeItem(index) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (cart.items[index]) {
        const item = cart.items[index];
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
        
        if (removeResponse.ok) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      }
    } catch (error) {
      console.error('Error removing item:', error);
    }
  },
  
  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;
        const countElements = document.querySelectorAll('#cart-count, #cart-count-mobile');
        countElements.forEach(el => {
          if (el) {
            el.textContent = count;
            if (count > 0) {
              el.style.display = 'inline-flex';
            } else {
              el.style.display = 'none';
            }
          }
        });
      });
  },
  
  checkout() {
    window.location.href = '/checkout';
  }
};

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer.init();
});